import React from 'react';
import { Row, Col, Skeleton } from 'antd';

interface LoadingSkeletonProps {
	loading?: boolean;
}

export function LoadingSkeleton({ loading = false }: Readonly<LoadingSkeletonProps>): JSX.Element | null {
	if (!loading) {
		return null;
	}

	return (
		<Row justify="center">
			<Col xs={23}>
				<Skeleton
					active
					title={false}
					paragraph={{
						rows: 3,
						width: '100%'
					}}
				/>
			</Col>
		</Row>
	);
}
